export { type BrandIconProps, BrandIconComponent } from "./BrandIcon";

import {
  AppleIcon,
  FacebookIcon,
  GitHubIcon,
  GoogleIcon,
  InstagramIcon,
  LinkedInIcon,
  MicrosoftIcon,
  SlackIcon,
  XIcon,
  MSTeamsIcon,
} from "./icons";

export type { BrandIcon } from "./icons";

export {
  AppleIcon,
  FacebookIcon,
  GitHubIcon,
  GoogleIcon,
  InstagramIcon,
  LinkedInIcon,
  MicrosoftIcon,
  SlackIcon,
  XIcon,
  MSTeamsIcon,
};

export const BRAND_ICONS = {
  microsoft: MicrosoftIcon,
  linkedin: LinkedInIcon,
  facebook: FacebookIcon,
  google: GoogleIcon,
  apple: AppleIcon,
  instagram: InstagramIcon,
  github: GitHubIcon,
  slack: SlackIcon,
  x: XIcon,
  teams: MSTeamsIcon,
} as const;

export type BrandIconName = keyof typeof BRAND_ICONS;
